import { Component, OnInit, OnDestroy } from '@angular/core';
import { MyAccountService } from '../../services/myAccount.service';
// tslint:disable-next-line:import-blacklist
import { Subject, Subscription } from 'rxjs';
import { B2brestApitokens } from '../../models/b2brestApitokens';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { ApiResponse } from '../../models/api-response.model';
import { CommonService } from '../../services';
import { AccountContact } from '../../models/Profile-view.model';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-apitokens',
  templateUrl: './apitokens.component.html',
  styleUrls: ['./apitokens.component.css']
})
export class ApitokensComponent implements OnInit, OnDestroy {

  title = 'API Tokens';
  liveOrTest = 'test'; // TODO: change to 'live' once switch to the live domain
  currentLiveToken: B2brestApitokens;
  loadContent = false;
  hasAdminAccess = false;
  modalDetails = {
    title: 'API Token Confirmation',
    content: 'The sandbox token has been generated successfully.'
  };
  showApiBox = false;
  accountId: string;
  companyCode: string;
  userList = [];
  selectedUserEmail: string;
  testURL: string;
  tokenLable = 'SANDBOX TOKEN';

  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private myAccountService: MyAccountService,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService,
  ) { }

  ngOnInit() {

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
     .subscribe((res: CurrentUserModel) => {
      if (res && res.hasAdminAccess) {
        this.accountId = res.accountId;
        this.companyCode = res.companyCode;

        // check if it is LIVE mode, then setup the test url
        if (this.companyCode === '1') { this.testURL = 'https://dev.dickerdata.com.au'; }
        if (this.companyCode === 'L02') { this.testURL = 'https://dev.dickerdata.co.nz'; }
         // set modal message & token label for LIVE
        if (this.testURL) {
          this.modalDetails.content = 'The production token has been generated successfully.';
          this.tokenLable = 'PRODUCTION TOKEN';
        }

        this.getAccountUserList();

        this.myAccountService.GetAPIIntegrationStatus().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: ApiResponse) => {
          if (response && response.status) {
            this.showApiBox = response.status;
          }
          if (res.isStaffAccount || this.showApiBox) {
            this.hasAdminAccess = res.hasAdminAccess;
            // Subscription: get the current live token
            this.myAccountService.getCurrentToken().pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data: B2brestApitokens) => {
                this.currentLiveToken = data;
                this.selectedUserEmail = this.currentLiveToken.integrationContactEmail;
              },
              error => { console.log(error); });
          } else {
            this.commonService.implementToast('Not allowed to API integration', 'Error');
            this.router.navigateByUrl('/myAccount');
          }
        },
        (error: any) => {
          console.error(error);
        });
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  close() {
    this.router.navigateByUrl('/myAccount');
  }

  generateToken() {

    if (!this.selectedUserEmail) {
      this.commonService.implementToast('Please select email from contact list or enter your own email address', 'Info');
      return;
    }

    if (!this.emailIsValid(this.selectedUserEmail)) {
      this.commonService.implementToast('Invalid email address', 'Info');
      return;
    }

    this.myAccountService.generateToken(this.selectedUserEmail).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (data: B2brestApitokens) => {

        this.currentLiveToken = data;

        $('#myModal').appendTo('body').modal('show');
      },
      error => { console.log(error); }
    );
  }

  getAccountUserList() {
    this.myAccountService.GetAccountUserList(this.accountId).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((result: any) => {

      if (result) {
        this.userList = result.filter(item => item.out_login_id !== '' && item.out_email !== '');
      }

    },
    (error: any) => {
      console.error(error);
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  emailIsValid (email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
